import { inject, Injectable } from '@angular/core';
import { DatiqAppConfig } from '@dat/datiq-core/models';
import { DatiqOptimizelyInitializerService } from '@dat/datiq-feature-flag';
import { Client } from '@optimizely/optimizely-sdk';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class IqTrendlinesOptimizelyInitializerService {
    private _optimizelyInitializer: DatiqOptimizelyInitializerService = inject(
        DatiqOptimizelyInitializerService,
    );
    constructor() {}

    initialize(config: DatiqAppConfig): Observable<Client> {
        return this._optimizelyInitializer.initialize(config);
    }
}
